import cx from 'classnames';
import Tooltip from 'lib/Tooltip';

type RadioProps = {
  isSelected: boolean;
  dataTestId?: string;
  onChange?: (newValue: boolean) => void;
  isDisabled?: boolean;
};

export const radioStyle = {
  base: 'border rounded-full shrink-0 cursor-pointer transition-colors',
  size: 'w-4 h-4',
  unselected: 'border-neutral-950-opacity-10 bg-neutral-50',
  unselectedInteractive:
    'hover:border-neutral-950-opacity-20 hover:bg-neutral-100 active:border-2 active:border-primary-600 active:bg-neutral-100',
  disabledUnselected: 'border-neutral-950-opacity-5 bg-neutral-950-opacity-5',
  selected: 'border-4 border-primary-700',
  selectedInteractive: 'hover:border-primary-600 active:border-primary-800',
  disabledSelected: 'border-4 border-neutral-300 bg-neutral-400',
};

const Radio: React.FC<RadioProps> = ({ isSelected, onChange, dataTestId, isDisabled = false }: RadioProps) => {
  return (
    <Tooltip tooltip={isSelected ? 'selected' : ''}>
      <button
        role="radio"
        type="button"
        onClick={() => !isDisabled && onChange?.(!isSelected)}
        aria-checked={isSelected}
        data-test-id={dataTestId}
        aria-label="radio button"
        className={cx(radioStyle.base, radioStyle.size, {
          [`${radioStyle.selected} ${radioStyle.selectedInteractive}`]: !isDisabled && isSelected,
          [`${radioStyle.unselected} ${radioStyle.unselectedInteractive}`]: !isDisabled && !isSelected,
          [radioStyle.disabledSelected]: isDisabled && isSelected,
          [radioStyle.disabledUnselected]: isDisabled && !isSelected,
        })}
      />
    </Tooltip>
  );
};

export default Radio;
